module.exports = __webpack_public_path__ + "packs/media/images/default_image-581c225e81a08041457b3f86f7326b01.png";